import { Outlet } from "react-router-dom";

import TopBanners from "components/TopBanners";


export default function TopBannersLayout() {
  return (
    <div className="size-full flex flex-col">
      <TopBanners />
      <div className="grow">
        <Outlet />
      </div>
    </div>
  );
};
